// extracted by mini-css-extract-plugin
export default {"asdfghjkl_asdfghjkl":"NewDeviceNotification_asdfghjkl_asdfghjkl__Iu6Xy","AllNotifications_wrapper__":"NewDeviceNotification_AllNotifications_wrapper____VM+rQ"};